import { Typography } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import { ConfirmModal } from "../../../../components/FormControls/ConfirmModal";
import { MissingAddressWarningState } from "./types";

interface IProps {
  warning: MissingAddressWarningState | null;
  onClose: () => void;
  onProceed: () => void;
}

export const MissingAddressWarningModal = ({
  warning,
  onClose,
  onProceed,
}: IProps) => {
  const { t } = useTranslation();

  if (!warning) {
    return null;
  }

  const hasValidCandidates = warning.validIds.length > 0;

  const confirmMessage = hasValidCandidates
    ? t("common.schoolCandidateModel.missingAddressWarningMessage")
    : t("common.schoolCandidateModel.missingAddressNoValidCandidates");

  const confirmText = hasValidCandidates
    ? t("common.schoolCandidateModel.missingAddressProceed")
    : t("common.close");

  const handleConfirm = () => {
    if (!hasValidCandidates) {
      onClose();

      return;
    }

    onProceed();
  };

  return (
    <ConfirmModal
      title={t("common.schoolCandidateModel.missingAddressWarningTitle")}
      confirmState="confirm"
      confirmMessage={confirmMessage}
      confirmText={confirmText}
      onClickClose={onClose}
      onClickConfirm={handleConfirm}
    >
      {warning.invalidCandidates.length > 0 && (
        <ul className="mt-2 mb-0 list-unstyled">
          {warning.invalidCandidates.map((candidate) => (
            <li key={candidate.schoolCandidateId}>
              <Typography variant="small">
                {candidate.firstName} {candidate.lastName}
              </Typography>
            </li>
          ))}
        </ul>
      )}
    </ConfirmModal>
  );
};
